<template>
    <div class="w-100 h-100 position-relative">
        <div class="bygginv-search position-absolute" style="top: 20px; left: calc(50% - 200px); width: 400px; z-index: 99; margin: 0 auto;">
            <b-input-group
                    size="lg"
                    class="mb-3"
            >
                <b-form-input></b-form-input>
                <b-input-group-append>
                    <b-button size="sm" text="Sök" variant="success">Sök</b-button>
                </b-input-group-append>
            </b-input-group>
        </div>
        <div id="byggmap" class="map-component" tabindex="0"></div>
    </div>
</template>

<script>
import Map from 'ol/Map'
import { defaults as defaultInteractions } from 'ol/interaction'
import View from 'ol/View'
import { fromLonLat } from 'ol/proj'
import wmtsLayer from '../map-component/layers/wmtsLayer'
import kulturarvOmraden from '../map-component/layers/kulturarvOmradenLayer';
import kulturarvByggnader from '../map-component/layers/kulturarvByggnaderLayer';
import kulturarvStadsdelar from '../map-component/layers/kulturarvStadsdelarLayer';
import * as olExtent from 'ol/extent';

export default {
  name: 'ByggnadsinvMap',
  data () {
    return {
      kulturarvOmradenLayer: null,
      kulturarvStadsdelarLayer: null,
      kulturarvByggnaderLayer: null
    }
  },

  mounted () {
    this.setupMap()
  },

  methods: {
    setupMap: function () {
      return new Promise(resolve => {
        this.map = new Map({
          interactions: defaultInteractions({
            onFocusOnly: true
          }),
          target: 'byggmap',
          layers: [],
          view: new View({
            center: fromLonLat([16.545025, 59.611366]),
            zoom: 13
          })
        })

        wmtsLayer().then(tileLayer => {
          this.map.addLayer(tileLayer)
        })

        this.kulturarvOmradenLayer = kulturarvOmraden('vasteras')
        this.map.addLayer(this.kulturarvOmradenLayer)

        this.kulturarvByggnaderLayer = kulturarvByggnader('vasteras')
        this.map.addLayer(this.kulturarvByggnaderLayer)

        this.kulturarvStadsdelarLayer = kulturarvStadsdelar('vasteras')
        this.map.addLayer(this.kulturarvStadsdelarLayer)

        const onMoveEnd = (evt) => {
          const map = evt.map
          console.log(map.getView().getResolution())
        }

        this.map.on('moveend', onMoveEnd)
      })
    }
  }
}
</script>
